export const captureException = (
  ...args: Parameters<NonNullable<NonNullable<Window['sm2']['sentry']>['captureException']>>
) => {
  return window.sm2.sentry?.captureException?.(...args);
};
